var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderExpirado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.013 1.4174H9.94727C10.1114 0.902579 10.0527 0.184118 10.6865 0.0554118C12.4671 0.142685 14.4018 -0.0953328 16.1658 0.0439517C16.915 0.103015 16.874 0.809135 17.013 1.4174Z",
    fill: "#EC3E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99951 18.9999V3.26785C8.99951 3.05363 9.39633 2.73186 9.61148 2.74773L17.3503 2.74597C17.5797 2.69925 17.9999 3.09683 17.9999 3.3084V18.9374C17.9999 18.9418 17.9447 18.9999 17.9405 18.9999H8.99951ZM12.8287 5.49111H11.5654V8.15162H12.8287V5.49111ZM15.3947 5.49111H14.1314V8.15162H15.3947V5.49111ZM12.8287 10.2294H11.5654V12.8899H12.8287V10.2294ZM15.3947 10.2294H14.1314V12.8899H15.3947V10.2294Z",
    fill: "#EC3E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73629 8.15161V10.8324C7.73629 10.8368 7.68104 10.895 7.67685 10.895H2.60527V12.2252H7.73713V14.2616H2.60527V15.5919H7.73713V18.9382C7.73713 18.9426 7.68187 19.0008 7.67769 19.0008H0V9.33729C0 8.86743 0.678945 8.15249 1.12516 8.15249H7.73713L7.73629 8.15161Z",
    fill: "#EC3E49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_1300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderExpirado);
export default __webpack_public_path__ + "static/media/providerExpirado.d019f12e6657e18257eef20dc953e6cb.svg";
export { ForwardRef as ReactComponent };